import { Col, Row } from "antd";
import React from "react";
const IncomeStaffJobId = ({ record }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (record) {
    const name = record?.name;
    return (
      <Col span={24}>
        <Row justify="space-between">
          <Col>Job ID:</Col>
          <Col>{name}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffJobId;
